export const sections = [
    { id: 'getting-started', title: 'Getting Started' },
    { 
      id: 'github-integration', 
      title: 'GitHub Integration',
      subsections: [
        { id: 'github-overview', title: 'Overview' },
        { id: 'github-setup', title: 'Setup Guide' },
        { id: 'github-configuration', title: 'Configuration' },
        { id: 'github-management', title: 'Management' }
      ]
    },
    { id: 'authentication', title: 'Authentication' },
    { id: 'integration', title: 'Integration Examples' },
    { 
      id: 'api-reference', 
      title: 'API Reference', 
      subsections: [
        { id: 'create-changelog', title: 'Create Changelog Entry' },
        { id: 'search-changelog', title: 'Search Changelog' },
        { id: 'list-changelog', title: 'List Changelog Entries' },
        { id: 'response-structure', title: 'Response Structure' },
        { id: 'rate-limits', title: 'Rate Limits' }
      ]
    }
  ];